import { IAnalyticsEvent, IAnalyticsException, IAnalyticsPageView, IAnalyticsTiming, IAnalyticsTransaction } from '@pressreader/analytics-types';
import { createActionCreator } from '@pressreader/appstore';

import { MODULE_NAME } from '../../constants';

const pre = `${MODULE_NAME}/generic/`;

const analyticsEventAction = createActionCreator<IAnalyticsEvent>(`${pre}event`);
const analyticsExceptionAction = createActionCreator<IAnalyticsException>(`${pre}exception`);
const analyticsPageViewAction = createActionCreator<IAnalyticsPageView>(`${pre}pageview`);
const analyticsTimingAction = createActionCreator<IAnalyticsTiming>(`${pre}timing`);
const analyticsPurchaseCompletedAction = createActionCreator<IAnalyticsTransaction>(`${pre}transaction`);

export { analyticsEventAction, analyticsExceptionAction, analyticsPageViewAction, analyticsTimingAction, analyticsPurchaseCompletedAction };
